import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';
import {ApiVersion} from '../constants/apis';
import {RetainedDocumentPage} from '../models/retained-document.model';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {CustomHttpParameterCodec} from '../utils/http-encoder';

@Injectable({
  providedIn: 'root'
})
export class SearchService extends AbstractService {

  constructor(private http: HttpClient) {
    super();
  }

  searchRetainedDocuments(query: string, pageSize: number, pageToken?: string): Observable<RetainedDocumentPage> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'documents/retained');
    let params = new HttpParams({encoder: new CustomHttpParameterCodec()})
      .set('query', query)
      .set('pageSize', String(pageSize));

    if (pageToken) {
      params = params.set('pageToken', pageToken);
    }

    return this.http.get<RetainedDocumentPage>(url, {params});
  }
}
